import { cachedHttp } from "./httpService";

const apiEndPoint = "/deepmodels/";

function getDeepModels() {
  return cachedHttp.get(apiEndPoint);
}

export default getDeepModels;
